// extracted by mini-css-extract-plugin
export default {"textWrapper":"note-default-template_textWrapper__yZ3vW"};